import { render, staticRenderFns } from "./userBlack.vue?vue&type=template&id=86db5b08&scoped=true"
import script from "./userBlack.vue?vue&type=script&lang=ts"
export * from "./userBlack.vue?vue&type=script&lang=ts"
import style0 from "./userBlack.vue?vue&type=style&index=0&id=86db5b08&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86db5b08",
  null
  
)

export default component.exports